<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-03-10 17:11:11
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-03-23 18:23:50
 * @FilePath: \crm-product\src\views\dms\views\sharing_agreement\cash_distribution\form\details\details.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';

export default {
  name: 'detail_table',
  extends: TablePage,
  data() {
    return {
      isCalculateHeight: false,
    };
  },
  props: {
    mainId: String,
  },
  methods: {},
  created() {
    console.log(this.mainId);
    this.params = { mainId: this.mainId };
    this.getConfigList('detail_list_table', null, null, 'CRM20260309000000002');
  },
};
</script>
